import { useContext } from 'react'
import type { Data, RawData, RsiProps } from '../types'
import type { MarkRequired } from 'ts-essentials'
import { RsiContext } from '../SpreadsheetProviders';

export const defaultRSIProps: Partial<RsiProps<any>> = {
    autoMapHeaders: true,
    allowInvalidSubmit: true,
    autoMapDistance: 2,
    uploadStepHook: async (value: any) => value,
    selectHeaderStepHook: async (headerValues: RawData, data: RawData[]) => ({ headerValues, data }),
    matchColumnsStepHook: async (table: Data<any>[]) => table,
    dateFormat: 'yyyy-mm-dd', // ISO 8601,
    parseRaw: true,
} as const



export const useRsi = <T extends string>() =>
    useContext<MarkRequired<RsiProps<T>, keyof typeof defaultRSIProps>>(RsiContext)
